import { render, staticRenderFns } from "./ImmediateCompensationDetailCard.vue?vue&type=template&id=2be55df2&scoped=true"
import script from "./ImmediateCompensationDetailCard.vue?vue&type=script&lang=ts"
export * from "./ImmediateCompensationDetailCard.vue?vue&type=script&lang=ts"
import style0 from "./ImmediateCompensationDetailCard.vue?vue&type=style&index=0&id=2be55df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be55df2",
  null
  
)

export default component.exports